import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';
import { CoreUtils } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas, SectionContainer } from '../../../../styles';
import { CommonGCGame } from '../../../../types';

export const MainContentContainer = styled.div`
    ${BaseStyle.Mixins.gaps.large}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.mainContent};
`;

const createGridTemplateAreas = (commonGameDetails: CommonGCGame) => {
    const gridItems = CoreUtils.isGameLive(commonGameDetails.gameState)
        ? [
              GameCenterComponentGridAreas.iceSheet,
              GameCenterComponentGridAreas.scoringSummary,
              GameCenterComponentGridAreas.penalties,
              window.__AD_SETTINGS__.mrecDivId ? GameCenterComponentGridAreas.ad : '',
              GameCenterComponentGridAreas.lineScore,
              commonGameDetails?.summary?.shotsByPeriod ? GameCenterComponentGridAreas.shotsOnGoal : '',
              GameCenterComponentGridAreas.gameStats,
              GameCenterComponentGridAreas.seasonSeries,
              GameCenterComponentGridAreas.gameInfoReports,
          ]
        : [
              GameCenterComponentGridAreas.gameRecap,
              GameCenterComponentGridAreas.scoringSummary,
              GameCenterComponentGridAreas.highlights,
              GameCenterComponentGridAreas.penalties,
              GameCenterComponentGridAreas.threeStars,
              window.__AD_SETTINGS__.mrecDivId ? GameCenterComponentGridAreas.ad : '',
              GameCenterComponentGridAreas.lineScore,
              commonGameDetails?.summary?.shotsByPeriod ? GameCenterComponentGridAreas.shotsOnGoal : '',
              GameCenterComponentGridAreas.gameStats,
              GameCenterComponentGridAreas.seasonSeries,
              GameCenterComponentGridAreas.gameInfoReports,
          ];
    return gridItems
        .filter((item) => item)
        .map((item) => `'${item}'`)
        .join('\n');
};

export const SummaryGameContainer = styled(SectionContainer)<{ $commonGameDetails: CommonGCGame }>`
    grid-template-areas: ${({ $commonGameDetails }) => createGridTemplateAreas($commonGameDetails)};
`;
